import { useCallback, useRef } from "react";

/**
 * Sequence guard for async loads so a slower older response cannot overwrite newer state
 * (e.g. All-events fetch finishing after an eventId drill-in fetch).
 *
 * @returns {() => { isCurrent: () => boolean }}
 */
export function useLatestRequestSeq() {
  const seqRef = useRef(0);
  return useCallback(() => {
    const seq = ++seqRef.current;
    return {
      isCurrent: () => seq === seqRef.current,
    };
  }, []);
}
